export default __webpack_public_path__ + "dbdf56099923991183a21364e97b12a3.svg";